import React, {
  ChangeEvent,
  forwardRef,
  HTMLInputTypeAttribute,
  useRef,
} from "react";

type UploaderProps = {
  onUpload: (e: ChangeEvent<HTMLInputElement>) => void;
  accept: string;
  type: HTMLInputTypeAttribute;
  children?: React.ReactNode;
  disabled?: boolean;
};

const BaseUploader = forwardRef<HTMLInputElement, UploaderProps>(
  ({ type, children, onUpload, accept, disabled }, ref) => {
    const id = useRef(Math.random().toString());

    return (
      <>
        <label htmlFor={id.current}>{children}</label>

        <input
          hidden
          ref={ref}
          type={type}
          id={id.current}
          accept={accept}
          disabled={disabled}
          onChange={onUpload}
        />
      </>
    );
  },
);

export default BaseUploader;
